<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 3C7.02943 3 3 7.02943 3 12C3 16.9705 7.02943 21 12 21C16.9705 21 21 16.9705 21 12C21 7.02943 16.9705 3 12 3ZM10.2 11.1C10.2 10.6029 10.6029 10.2 11.1 10.2H12C12.4971 10.2 12.9 10.6029 12.9 11.1V15.6C12.9 16.0971 12.4971 16.5 12 16.5C11.5029 16.5 11.1 16.0971 11.1 15.6V12C10.6029 12 10.2 11.5971 10.2 11.1ZM12 7.5C11.5029 7.5 11.1 7.90295 11.1 8.4C11.1 8.89705 11.5029 9.3 12 9.3C12.4971 9.3 12.9 8.89705 12.9 8.4C12.9 7.90295 12.4971 7.5 12 7.5Z"
    />
  </svg>
</template>
